const REGION_CONFIG_MAP = Object.freeze({
    uk: Object.freeze({
        currency: 'GBP',
        language: 'en-GB',
        timeZone: 'Europe/London',
        termsUrl: 'https://sorenson.co.uk/terms-of-use/',
        privacyUrl: 'https://sorenson.co.uk/privacy-policy/',
        websiteUrl: 'https://sorenson.co.uk/',
        forumUrl: 'https://forum.sorenson.co.uk/',
        supportEmail: 'ukforumsupport@sorenson.com',
        privacyPortalUrl: 'https://sorensonuk-privacyportal-ui.merudata.app/privacy-request/sorensonuk/uk-customer',
    }),
    global: Object.freeze({
        currency: 'USD',
        language: 'en-US',
        timeZone: 'America/New_York',
        termsUrl: 'https://sorenson.com/legal/terms-of-use/',
        privacyUrl: 'https://sorenson.com/legal/privacy-policy/',
        websiteUrl: 'https://www.sorenson.com',
        forumUrl: 'https://forum.sorensoncloud.com/',
        supportEmail: 'forumsupport@sorenson.com',
        privacyPortalUrl: 'https://sorenson-gpc-loader.merudata.app/',
    }),
});

const normalizeEnvValue = (value) => String(value ?? '').trim().replace(/^['"]|['"]$/g, '');
const DEFAULT_REGION = 'global';
const REGION_ENV = normalizeEnvValue(process.env.VUE_APP_REGION || DEFAULT_REGION).toLowerCase();
const REGION = REGION_CONFIG_MAP[REGION_ENV] ? REGION_ENV : DEFAULT_REGION;
const PURCHASE_ENABLED = normalizeEnvValue(process.env.VUE_APP_PURCHASE_ENABLED).toLowerCase() !== 'false';
const SHOW_PRICES = normalizeEnvValue(process.env.VUE_APP_SHOW_PRICES).toLowerCase() !== 'false';
const CUSTOM_VOCAB_ENABLED = normalizeEnvValue(process.env.VUE_APP_CUSTOM_VOCAB_ENABLE).toLowerCase() === 'true';
const PARTICIPANTS_LIST_ENABLED = normalizeEnvValue(process.env.VUE_APP_PARTICIPANTS_LIST_ENABLED).toLowerCase() === 'true';
const OBS_OVERLAY_ENABLED = normalizeEnvValue(process.env.VUE_APP_OBS_OVERLAY_ENABLED).toLowerCase() === 'true';

export const Constants = Object.freeze({
    API_URL: process.env.VUE_APP_API_URL,
    API_URL_V2: process.env.VUE_APP_API_URL_V2,
    NODE_API_PREFIX: '/api',
    AUTH0_DOMAIN: process.env.VUE_APP_AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: process.env.VUE_APP_AUTH0_CLIENT_ID,
    AUTH0_AUDIENCE: process.env.VUE_APP_AUTH0_AUDIENCE,
    LD_CLIENT_ID: normalizeEnvValue(process.env.VUE_APP_LD_CLIENT_ID),
    DEFAULT_REGION,
    REGION,
    REGION_CONFIG: REGION_CONFIG_MAP[REGION],
    REGION_CONFIG_MAP,
    DEFAULT_LANGUAGE: REGION_CONFIG_MAP[REGION].language,
    PURCHASE_ENABLED,
    SHOW_PRICES,
    CUSTOM_VOCAB_ENABLED,
    PARTICIPANTS_LIST_ENABLED,
    OBS_OVERLAY_ENABLED,
    // Caption font styles offered in Caption Settings. Only the style key is stored in settings,
    // so the actual fonts can be swapped here without migrating what users have saved.
    CAPTION_FONTS: Object.freeze({
        sans: "Inter, sans-serif",
        serif: "'Noto Serif', serif",
    }),
});
